import { components, SingleValueProps } from 'react-select';
import Avatar from 'react-avatar';
import { GrLocation } from 'react-icons/gr';

export type CustomSingleValueProps = {
  workerName: string;
  avatar: string;
  distance: string;
};

export default function CustomSingleValue({
  children,
  workerName,
  avatar,
  distance,
  ...props
}: SingleValueProps & CustomSingleValueProps) {
  return (
    <components.SingleValue {...props}>
      <div className="d-flex align-items-center">
        <Avatar size="30" round src={avatar} className="me-2" />
        <div>
          <div className="fw-bold">{workerName}</div>
          <GrLocation className="me-1 mb-1" />
          {distance}
        </div>
      </div>
    </components.SingleValue>
  );
}
